import React, { Component} from 'react';

import {connect} from "react-redux";
import { withRouter } from "react-router-dom";
import {logoutRequest} from "../login/login-action-creators";
import Nav from "./nav-component";
import {showAddWordsModal} from "../add-words/add-words-action-creators";



class NavContainer extends Component {

  goBack = ({ showModal }) => {
    showModal ? this.props.showModal() : null;
    this.props.history.goBack();
  };
  backToReportsList = () => this.props.history.push('/reports');
  goToAddReport = () => this.props.history.push("/add-report");
  goHome = () => this.props.history.push("/");

  render() {
    return (
      <Nav
        {...this.props}
        goBack={this.goBack}
        backToReportsList={this.backToReportsList}
        goToAddReport={this.goToAddReport}
        goHome={this.goHome}
      />
    )
  }
}



const mapStateToProps = state => ({
  token: state.login.token
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  logout: () => dispatch(logoutRequest(ownProps.history)),
  showModal: () => dispatch(showAddWordsModal())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavContainer))


// WEBPACK FOOTER //
// ./src/modules/nav/nav-container.js